'use client'

import { Icon } from 'shared/iconpack'
import { clsx } from 'shared/libs/style-merge'

import React, { ButtonHTMLAttributes, DetailedHTMLProps } from 'react'

import styles from './MoreButton.module.scss'

interface MoreButtonProps
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  variant?: 'brand' | 'secondary'
  iconName?: 'chevronLeft' | 'chevronRight'
  text?: string
}

export function MoreButton({
  type = 'button',
  className,
  disabled,
  variant = 'brand',
  text = 'Показать больше',
  iconName = 'chevronLeft',
  ...props
}: MoreButtonProps) {
  return (
    <button
      className={clsx(styles.moreButton, styles[variant], className)}
      type={type}
      disabled={disabled}
      {...props}
    >
      {text}
      <Icon name={iconName} size={16} className={styles.icon} />
    </button>
  )
}
